import { useState, useEffect } from 'react';

const images = [
  'https://static.readdy.ai/image/288893c5c915d12784f7c7fb5a449e01/4229597ac5e5149f030e72fbc8980474.jpeg',
  'https://static.readdy.ai/image/288893c5c915d12784f7c7fb5a449e01/203e112dadd9ff8b437cbab55528c185.png'
];

export default function FinalCTA() {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-white">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-extrabold mb-3 text-gray-950">
          우리집 익스프레스가 여러분의
          <br />
          <span className="text-teal-600">행복한 이사를 책임지겠습니다.</span>
        </h2>

        <p className="text-sm md:text-base text-gray-700 mb-8 md:mb-12 leading-relaxed font-medium px-2">
          한번 고객은 영원한 고객이라는 신조로 이사 후 사후 관리에도 수고를 아끼지 않는 고객만족 1위의 기업이 되겠습니다.
          <br className="hidden md:block" />
          고객님의 작은 소리에도 늘 귀 기울이는 고객만족을 위해 보다 노력하는 기업이 되겠습니다.
        </p>

        <div className="relative w-full h-56 md:h-96 rounded-lg overflow-hidden">
          {images.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentImage ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img
                src={image}
                alt={`이사 현장 ${index + 1}`}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
